import {
  EnrollmentContext,
  BenefitsPageResponseDto,
  BenefitDto,
} from 'theSource/queries';

const CURRENT = 'Current';
const PREVIOUS = 'Past';
const FUTURE = 'Future';

export const contextTypes = [CURRENT, PREVIOUS, FUTURE];

interface ContextInfo {
  startsOn: string;
  endsOn: string;
  opyIds?: Set<number>;
}

export const mapPlanYearDates = (benefits?: BenefitDto[]): ContextInfo => {
  let startsOn = '';
  let endsOn = '';
  const opyIds = new Set<number>();
  if (benefits && benefits.length > 0) {
    let earliestStart: Date = new Date(
      benefits[0].coverage?.plan_year_start_date
    );
    let latestEnd: Date = new Date(benefits[0].coverage?.plan_year_end_date);

    benefits.forEach((benefit) => {
      if (benefit.coverage) {
        const startsOn = new Date(benefit.coverage.plan_year_start_date);
        const endsOn = new Date(benefit.coverage.plan_year_end_date);

        opyIds.add(benefit.org_plan_year_id);

        if (startsOn < earliestStart) {
          earliestStart = startsOn;
        }

        if (endsOn > latestEnd) {
          latestEnd = endsOn;
        }
      }
    });

    startsOn = String(earliestStart);
    endsOn = String(latestEnd);
  }

  return { startsOn, endsOn, opyIds };
};

export const mapBenefitsForContext = (
  data?: BenefitsPageResponseDto,
  contextName?: string
) => {
  if (!data) {
    return [];
  }
  const { current, previous, next } = data.data;

  switch (contextName) {
    case CURRENT:
      return current;
    case PREVIOUS:
      return previous;
    case FUTURE:
      return next;
    default:
      return current;
  }
};

export const filterContextsByType = (
  contextName: string,
  contexts?: EnrollmentContext[]
) => {
  switch (contextName) {
    case CURRENT:
      return contexts?.filter(
        (context) =>
          context.plan_year_starts_on > new Date() &&
          context.plan_year_starts_on < new Date()
      );
    case PREVIOUS:
      return contexts?.filter(
        (context) =>
          context.plan_year_starts_on < new Date() &&
          context.plan_year_ends_on < new Date()
      );
    case FUTURE:
      return contexts?.filter(
        (context) =>
          context.plan_year_starts_on > new Date() &&
          context.plan_year_ends_on > new Date()
      );
    default:
      return contexts?.filter(
        (context) =>
          context.plan_year_ends_on < new Date() &&
          context.plan_year_starts_on > new Date()
      );
  }
};
